import { useEffect, useState } from "react";
import { selector } from "../../../api";
import { TableShared } from "../../../shared";
import { char, number } from "../../../utils";
import { Button, Dropdown, Image, Input, Select, Space, Tooltip } from "antd";
import { MoreOutlined, SearchOutlined } from "@ant-design/icons";
import { Avatar } from "rsuite";
import { appCRUD } from "../../../actions/app";
import { StudentAdd } from "./add";
import { useNavigate } from "react-router-dom";

export const StudentContent = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0);
  const [name, setName] = useState("");
  const [registration, setRegistration] = useState("")
  const [programmes, setProgrammes] = useState([])
  const [search, setSearch] = useState("")
  const [programme, setProgramme] = useState("")
  const [level, setLevel] = useState("")
  const [study, setStudy] = useState("")
  const [verified, setVerified] = useState("")
  const [index, setIndex] = useState(0);
  const user = selector.User();

  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      appCRUD.loadProgrammeList(10, 0, search, "name").then((resp) => {
        setProgrammes(resp.data.results)
      }).catch(() => {})
    },500)
  },[search])

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      if(user){
        if (user.is_student) {
          appCRUD
            .loadActiveStudentByStudent(
              postsPerPage,
              nextPage,
              user.username,
              "full_name"
            )
            .then((resp) => {
              setData(resp.data.results);
              setCount(resp.data.count);
            })
            .catch((error) => {})
            .finally(() => {
              setLoading(false);
            });
        } else {
          appCRUD
            .loadActiveStudentByFilter(
              postsPerPage,
              nextPage,
              name,
              registration,
              programme ? programme : "",
              level ? level : "",
              study ? study : "",
              verified ? (verified === 1 ? true : false) : "",
              "full_name"
            )
            .then((resp) => {
              setData(resp.data.results);
              setCount(resp.data.count);
            })
            .catch((error) => {})
            .finally(() => {
              setLoading(false);
            });
        }
      }
    }, 500);
  }, [page, postsPerPage, user, index, nextPage]);


  const startIndex = (page - 1) * postsPerPage + 1;

  const defaultColumns = [
    {
      key: "sn",
      title: "#",
      dataIndex: "sn",
      fixed: true,
      width: 50,
    },
    {
      title: "Image",
      key: "operation",
      align: "center",
      width: 70,
      render: (record) =>
        record.photo ? (
          <Image
            src={record.photo}
            width={30} // adjust size
            height={30} // optional if you want fixed square
            style={{
              border: "1px solid #cccccc",
              borderRadius: 4,
              objectFit: "cover",
            }}
          />
        ) : (
          <Avatar bordered square size="sm" />
        ),
    },
    {
      key: "reg",
      title: "Registation",
      dataIndex: "reg",
      sortable: true,
      width: 100,
    },
    {
      key: "full_name",
      title: "Full Name",
      dataIndex: "full_name",
      sortable: true,
      width: 230,
      render: (email) => {
        const short =
          email.length > 30 ? email.substring(0, 30) + "..." : email;

        return (
          <Tooltip title={email}>
            <span>{short}</span>
          </Tooltip>
        );
      },
    },
    {
      key: "address",
      title: "Address",
      dataIndex: "address",
      sortable: true,
      width: 160,
      render: (email) => {
        const short =
          email.length > 20 ? email.substring(0, 20) + "..." : email;

        return (
          <Tooltip title={email}>
            <span>{short}</span>
          </Tooltip>
        );
      },
    },
    {
      key: "phone",
      title: "Phone No.",
      dataIndex: "phone",
      sortable: true,
      width: 100,
    },
    {
      key: "email",
      title: "Email",
      dataIndex: "email",
      sortable: true,
      width: 160,
      render: (email) => {
        const short =
          email.length > 20 ? email.substring(0, 20) + "..." : email;

        return (
          <Tooltip title={email}>
            <span>{short}</span>
          </Tooltip>
        );
      },
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      width: 80,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 70,
      render: (record) => (
        <Dropdown
          menu={{
            items: [
              {
                label: "View",
                key: "view",
                icon: <i className="ri-eye-line" />,
              },
            ],
            onClick: (event) => {
              switch (event.key) {
                case "view":
                  navigate("/student", {
                    state: {
                      page: "detail",
                      dataId: record.id,
                    },
                  });
                  break;
                default:
              }
            },
          }}
          trigger={["click"]}
          placement="bottomRight"
          arrow={{ pointAtCenter: true }}
        >
          <Space>
            <Button type="dashed" icon={<MoreOutlined />} size={"small"} />
          </Space>
        </Dropdown>
      ),
    },
  ];

  const dataItem = data?.map((dt, i) => ({
    id: dt.id,
    photo: dt.photo,
    sn: number.fNumber(startIndex + i),
    reg: dt.registration_number ? dt.registration_number : "N/A",
    full_name: dt.full_name ? char.toTitleCase(dt.full_name) : "N/A",
    address: dt.address ? char.toTitleCase(dt.address) : "N/A",
    phone: dt.phone_number ? dt.phone_number : "N/A",
    email: dt.email ? dt.email : "N/A",
    status: dt.is_printed ? (
      <span class="badge badge-soft-success badge-border fs-11">
        {char.toTitleCase("printed")}
      </span>
    ) : dt.is_verified ? (
      <span class="badge badge-soft-success badge-border fs-11">
        {char.toTitleCase("verified")}
      </span>
    ) : (
      <span class="badge badge-soft-danger badge-border fs-11">
        {char.toTitleCase("not verified")}
      </span>
    ),
  }));

  const button = (
    <button className="btn btn-primary" onClick={() => setOpen(true)}>
      <span className="bi bi-plus-circle la-lg"></span> &nbsp; New Student
    </button>
  );

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  
  

  return (
    <>
      <StudentAdd
        open={open}
        setOpen={setOpen}
        index={index}
        setIndex={setIndex}
      />
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-12">
            <p className="h6 fs-18 fw-bold text-primary">Student</p>
          </div>
          <hr className="mt-3" />
        </div>
        <div className="row mb-2 ">
          <div className="col-12 card card-body p-3">
            <div className="row">
              <div className="col-md-2 col-sm-12">
                <Input
                  size="large"
                  placeholder="Full name"
                  allowClear
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="col-md-2 col-sm-12">
                <Input
                  size="large"
                  placeholder="Registration Number"
                  allowClear
                  onChange={(e) => setRegistration(e.target.value)}
                />
              </div>
              <div className="col-md-2 col-sm-12">
                <Select
                  size="large"
                  className="w-100"
                  showSearch
                  allowClear
                  placeholder="Select programme"
                  optionFilterProp="children"
                  onChange={(value) => {
                    setProgramme(value);
                  }}
                  onClear={() => {
                    setProgramme("");
                  }}
                  onSearch={(value) => setSearch(value)}
                  filterOption={filterOption}
                  options={programmes?.map((dt) => ({
                    value: dt.id,
                    label:
                      char.toUpperCase(dt.code) +
                      " - " +
                      char.toUpperCase(dt.name),
                  }))}
                />
              </div>
              <div className="col-md-2 col-sm-12">
                <Select
                  size="large"
                  className="w-100"
                  showSearch
                  allowClear
                  placeholder="Select qualification level"
                  optionFilterProp="children"
                  onChange={(value) => {
                    setLevel(value);
                  }}
                  onClear={() => {
                    setLevel("");
                  }}
                  filterOption={filterOption}
                  options={[
                    { value: "undergraduate", label: "Undergraduate" },
                    { value: "postgraduate", label: "Postgraduate" },
                  ]}
                />
              </div>
              <div className="col-md-2 col-sm-12">
                <Select
                  size="large"
                  className="w-100"
                  showSearch
                  allowClear
                  placeholder="Select study year"
                  optionFilterProp="children"
                  onChange={(value) => {
                    setStudy(value);
                  }}
                  onClear={() => {
                    setStudy("");
                  }}
                  filterOption={filterOption}
                  options={[
                    { value: 1, label: "First Year" },
                    { value: 2, label: "Second Year" },
                    { value: 3, label: "Third Year" },
                    { value: 4, label: "Fourth Year" },
                    { value: 5, label: "Fifth Year" },
                  ]}
                />
              </div>
              <div className="col-md-2 col-sm-12">
                <Select
                  size="large"
                  className="w-100"
                  showSearch
                  allowClear
                  placeholder="Select status"
                  optionFilterProp="children"
                  onChange={(value) => {
                    setVerified(value);
                  }}
                  onClear={() => {
                    setVerified("");
                  }}
                  filterOption={filterOption}
                  options={[
                    { value: 1, label: "Verified" },
                    { value: 2, label: "Not Verified" },
                  ]}
                />
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-5" />
              <div className="col-md-2 col-sm-12 text-center">
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  loading={loading}
                  style={{
                    backgroundColor: "#1677ff", // customize here
                    borderColor: "#1677ff",
                  }}
                  onClick={() => setIndex(index + 1)}
                >
                  Search
                </Button>
              </div>
              <div className="col-5" />
            </div>
          </div>
        </div>
        <TableShared
          setOpen={setOpen}
          loading={loading}
          data={dataItem}
          setData={setData}
          page={page}
          setPage={setPage}
          count={count}
          postsPerPage={postsPerPage}
          setePostPerPage={setePostPerPage}
          setNextPage={setNextPage}
          value={null}
          setValue={null}
          defaultColumns={defaultColumns}
          button={button}
          link={"#"}
          showButton={true}
          setLoading={setLoading}
        />
      </div>
    </>
  );
};
